export const environment = {
  production: false,
  apiUrl: 'https://api.transformer.platform.qa.transflo.com/api/v1',
};
